<!-- Verdict label of a creator or an analysed video: green for an approval ('Promosso', 'Video Promosso'), red otherwise
     (fixed colours, docs/architecture.md); the stored value is shown with tv(). Nothing without a verdict. -->
<script setup lang="ts">
import { useI18n } from '../composables/useI18n'
import { verdictOk } from '../features/creators'

defineProps<{ verdict?: string }>()
const { tv } = useI18n()
</script>

<template>
  <span v-if="verdict" :class="['text-[10px] font-bold px-2 py-0.5 rounded-full border', verdictOk(verdict) ? 'bg-green-500/15 text-green-400 border-green-500/30' : 'bg-red-500/15 text-red-400 border-red-500/30']">{{ tv(verdict) }}</span>
</template>
